module.exports = __webpack_public_path__ + "img/hazardEquip45.b80e741d.png";